"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueChooserPopover = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const SearchBox_1 = __importDefault(require("@opsbase/web-textfield/SearchBox"));
const NonModalPopover_1 = __importDefault(require("@opsbase/web-ui/NonModalPopover"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const react_1 = __importStar(require("react"));
const AddNewBar_1 = __importDefault(require("../core/AddNewBar"));
const useValueChooserLoader_1 = __importStar(require("./useValueChooserLoader"));
const ValueChooserPopoverList_1 = __importDefault(require("./ValueChooserPopoverList"));
const LIST_HEIGHT = 300;
const makeMyClasses = hasItems => ({
    root: {
        minWidth: 250,
        width: 'calc(100%)',
        height: hasItems ? LIST_HEIGHT || 'calc(100%)' : undefined,
        minHeight: hasItems ? LIST_HEIGHT : undefined,
        maxHeight: LIST_HEIGHT,
        overflow: 'hidden',
        borderRadius: 3,
        border: `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
    },
});
function ValueChooserPopover(props) {
    const { open = false, anchorEl, onClose, value, onChange, type, right = false, multi = false, onAddNew, addLabel = lib_i18n_1.default.t('create-new'), } = props;
    const [state, setState] = (0, react_1.useState)((0, useValueChooserLoader_1.initLoaderState)(props));
    const [initialized, setInitialized] = (0, react_1.useState)(false);
    const { items, loading, refetch, totalCount } = (0, useValueChooserLoader_1.default)(state);
    const hasItems = !!items.length;
    if (!loading && !initialized)
        setInitialized(true);
    const isPlace = type === DataType_1.default.PLACE;
    const showSearchBar = isPlace || totalCount > 15;
    const myCss = (0, web_css_1.default)(makeMyClasses, [hasItems]);
    const doChange = (0, react_1.useMemo)(() => v => {
        v = !v ? [] : (0, isArray_1.default)(v) ? v : [v];
        onChange === null || onChange === void 0 ? void 0 : onChange(v || []);
    }, [onChange]);
    const handleToggleItem = (0, react_1.useCallback)(item => {
        if (value.find(i => i === item)) {
            doChange([...value.filter(s => s !== item)]);
        }
        else {
            doChange(multi ? [...value, item] : [item]);
        }
    }, [doChange, multi, value]);
    const handleAddNew = (0, react_1.useCallback)((newTitle) => __awaiter(this, void 0, void 0, function* () {
        const newItem = yield onAddNew(newTitle);
        state.extraValues = [...(state.extraValues || []), newItem];
        handleToggleItem(newItem);
        items.push(newItem);
        refetch();
        return newItem;
    }), [onAddNew, state, handleToggleItem, items, refetch]);
    const handleLoadMore = (0, react_1.useCallback)(() => {
        const offset = state.offset + state.limit || 0;
        if (items && offset < totalCount) {
            setState(Object.assign(Object.assign({}, state), { offset }));
        }
    }, [items, state, totalCount]);
    const handleSearch = (0, react_1.useCallback)(keyword => {
        setState(Object.assign(Object.assign({}, state), { keyword, offset: 0 }));
    }, [state]);
    const listBit = (0, react_1.useMemo)(() => (react_1.default.createElement(ValueChooserPopoverList_1.default, { loading: loading, onLoadMore: handleLoadMore, onClickItem: handleToggleItem, items: items, selectedItems: value })), [handleLoadMore, handleToggleItem, items, loading, value]);
    return (react_1.default.createElement(NonModalPopover_1.default, { open: open, onClose: onClose, anchorEl: anchorEl, placement: right ? 'bottom-end' : 'bottom-start' },
        react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.root } },
            initialized && !!showSearchBar && (react_1.default.createElement(SearchBox_1.default, { keyword: state.keyword, onChange: handleSearch })),
            hasItems && listBit,
            initialized && !!onAddNew && (react_1.default.createElement(AddNewBar_1.default, { addLabel: addLabel, onAddNew: handleAddNew })))));
}
exports.ValueChooserPopover = ValueChooserPopover;
exports.default = ValueChooserPopover;
